module.exports = __webpack_public_path__ + "img/Icon-AppsSidebar.7fead7fb.svg";